@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.label {
  margin: 0;
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--brand-700, #{$color-brand-700});
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.pill {
  padding: 8px 16px;
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface, #fff);
  border: 1px solid $color-neutral-200;
  border-radius: 10px;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: $color-brand-700;
  }
}

.pillOn {
  color: #fff;
  background: $color-green-primary-500;
  border-color: $color-green-primary-500;
}
